import React, { useState } from "react";

const FileDownloader = ({ url , title}) => {
  const [isDownloading, setIsDownloading] = useState(false); // State for loader

  const handleDownload = async () => {
    try {
      setIsDownloading(true); // Show loader
      
      // Create a link element to download the file
      const link = document.createElement("a");
      
      const fileName = title; // Extract file name from URL
      link.href = url;
      link.download = fileName || "downloaded-file"; // Default name if none

      // Trigger the download
      document.body.appendChild(link);
      link.click();


      setTimeout(() => {
        setIsDownloading(false)
      }, 1000);

      // Clean up
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Error downloading file:", error.message);
    }
  };

  return (
    <div>
      {isDownloading ? (
        <img
          src="/icons/loading-spinner.gif" // Loader icon
          className="w-[24px] cursor-pointer"
          alt="Downloading..."
        />
      ) : (
        <img
          src="/icons/download.png" // Download icon
          className="w-[24px] cursor-pointer"
          onClick={handleDownload} // Download logic
          alt="Download"
        />
      )}
    </div>
  );
};

export default FileDownloader;
